module.exports = __webpack_public_path__ + "img/edit.09d3a183.svg";